import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { Nav, Accordion, Image } from "react-bootstrap";
import { Placeholder } from "react-bootstrap";
import logo from "../../../images/logo.png";
import "./_navbar.scss";
import { Scrollbars } from "react-custom-scrollbars";
import * as Cookies from "es-cookie";
import StudentAttendanceImg from '../../../images/Studnet attendancenew.png'
import StudentAtnReportImg from '../../../images/student attendance reportnew.png'
import HostelAtnImp from '../../../images/Hostel attendancenew.png'
import HostelAtnReportImp from '../../../images/Hostel attendance reportnew.png'
import EmpAttendanceImg from '../../../images/Employee attendancenew.png'
import EmpAttendanceReportImg from '../../../images/employee attendance reportnew.png'
import ExamMarkUploadImg from '../../../images/Exam mark uploadnew.png'
import OfflineExamReportImg from '../../../images/offline exam reportnew.png'
import FeeDetailsImg from '../../../images/Fee detailsnew.png'
import AdmissionFormImg from '../../../images/Admission formnew.png'
import EnrolledStudentsImg from '../../../images/enrolled studentsnew.png'
import EnquiryLinksImg from '../../../images/Enquiry linksnew.png'
import LeadManagementImg from '../../../images/Lead managementnew.png'
import DiaryImg from '../../../images/students diarynew.png'
import AssignmentsImg from '../../../images/Student assignmentnew.png'
import ExamReportsImg from '../../../images/Exam reportsnew.png'
import PermissionsImg from '../../../images/Student permissionnew.png'
import GatePassImg from '../../../images/gate passnew.png'
import NotifyParentsImg from '../../../images/Notify parentsnew.png'
import LecturerTimetableImg from '../../../images/Lecturer timetablenew.png'
import MaterialCreationImg from '../../../images/Material creationnew.png'
import ExamCreationImg from '../../../images/exam creationnew.png'
import ManageExamsImg from '../../../images/exam managemntnew.png'
import QuizCreationImg from '../../../images/Quiz creationnew.png'
import NotifyStudentsImg from '../../../images/Notify studentsnew.png'
import ExamCreation from "../../../images/exam creation.svg"
import ExamManagement from "../../../images/exam management.svg"
import StudentProfile from "../../../images/student profile.svg"
import gifimg from "../../../images/new-gif-icon.png";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import college_logo from '../../../images/dinesh_publications.gif';

import logoBlue from '../../../images/logo-blue.png';
import logoWhite from '../../../images/logo-white.png';

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    width: "3px",
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

class SideNavbar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      rizeeLogo: true
    }
  }
  getAccordianActive = () => {
    switch (this.props.history.location.pathname) {
      // Questions
      case "/questions/create-question-paper":
        return 1;
      case "/questions/question-pattern":
        return 1;
      case "/questions/question-pattern/create-question-pattern":
        return 1;
      case "/questions/manage-question-paper":
        return 7;
      case "/questions/create-question-paper/own-question-paper":
        return 1;
      case "/questions/manage-question-paper/question-paper-result":
        return 1;
      case "/questions/create-question-paper/adaptive-question-paper":
        return 1;
      case "/questions/create-question-paper/create-custom-question-paper":
        return 1;
      case "/questions/create-question-paper/create-custom-question-paper/create-custom-summery":
        return 1;
      case "/questions/our-questions/manage-our-question-paper":
        return 1;
      case "/questions/create-question-paper/error-question":
        return 1;
      case "/questions/create-question-paper/old-public-exam":
        return 1;
      case "/questions/our-questions":
        return 1;
      case "/quiz_section":
        return 7;
      case "/exam_made_easy":
        return 7;
      case "/admission_form":
        return 1;
      case "/student-admission-list":
        return 4;
      case "/lec_paper_generator":
        return 1;
      case "/mocktest-analysis":
        return 1;
      case "/student/attendance":
        return 3;
      case "/student/attendance-report":
        return 3;
      case "/student/marks-upload":
        return 6
      case "/student/offline-fee-structure":
        return 1
      case "/student/offline-exam-results":
        return 6
      case "/Fee-Structure":
        return 1
      case "/Employee_Attendance":
        return 3
      case "/Employee_Attendance_Report":
        return 3
      case "/Student_Gate_Pass":
        return 8
      case "/student-admission":
        return 4
      case "/settings/instituteStudents":
        return 1
      case "/Parent_Notification":
        return 1
      case "/student-permission":
        return 8;
      case "/student-diary":
        return 5;
      case "/settings/notify-students":
        return 1;
      case "/hostel-attendance":
        return 3;
      case "/hostel/attendance-report":
        return 3;
      case "/assignment":
        return 5;
      case "/enquiry-links":
        return 4
      case "/lead-management-home":
        return 4
      case "/inst_revision_material":
        return 1;
      // settings
      case "/building-creation":
        return 1;
      case "/settings/user-creations":
        return 2;
      case "/settings/employee-restrictions":
        return 2;
      case "/settings/package":
        return 2;
      case "/settings/category":
        return 2;
      case "/settings/add-section":
        return 2;
      case "/settings/branches":
        return 2;
      case "/settings/students":
        return 1;
      case "/settings/teachers":
        return 2;
      case "/settings/groups":
        return 2;
      case "/settings/organization-setup":
        return 2;
      case "/settings/organization-profile":
        return 2;
      case "/settings/promote-students":
        return 2;
      case "/settings/promote-students/promote-class":
        return 2;
      case "/settings/promote-students/promote-exit-class":
        return 2;

      case "/admissions-dashboard":
        return 4;
      case "/communications-center":
        return 0;

      default:
        return 0;
    }
  };

  getActiveClass = link => {

    if (link === this.props.history.location.pathname)
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/settings/promote-students/promote-class" &&
      link === "/settings/promote-students"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/settings/promote-students/promote-exit-class" &&
      link === "/settings/promote-students"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/question-pattern/create-question-pattern" &&
      link === "/questions/question-pattern"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/own-question-paper" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/manage-question-paper/question-paper-result" &&
      link === "/questions/manage-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/adaptive-question-paper" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/create-custom-question-paper" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/create-custom-question-paper/create-custom-summery" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/our-questions/manage-our-question-paper" &&
      link === "/questions/our-questions"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/error-question" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/un-answered" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/questions/create-question-paper/old-public-exam" &&
      link === "/questions/create-question-paper"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/quiz_section" &&
      link === "/quiz_section"
    )
      return "collapse-item active";
    else if (
      this.props.history.location.pathname ===
      "/mocktest-analysis" &&
      link === "/mocktest-analysis"
    )
      return "collapse-item active";

    else if (
      this.props.history.location.pathname ===
      "/settings/employee-restrictions" &&
      link === "/settings/employee-restrictions"
    )
      return "collapse-item active";

    else return "collapse-item";
  };

  getActiveClassTwo = link => {
    if (link === this.props.history.location.pathname)
      return "nav-link active";
    else
      return "nav-link";
  };


  componentDidMount = () => {
    const domain = window.location.hostname;
    let rizeeLogo = domain === "college.rizee.in";

    this.setState({
      rizeeLogo: rizeeLogo
    });
  }

  render() {

    let moduleRestrictions = ''

    if (JSON.parse(localStorage.getItem("moduleRestrictions")) != undefined && JSON.parse(localStorage.getItem("moduleRestrictions")) != "") {
      moduleRestrictions = JSON.parse(localStorage.getItem("moduleRestrictions"))
    }

    console.log("toggled", Cookies.get("toggle"))

    return (
      <div className="">
        <div className="sidebar-header mb-0 px-2 py-2">

          <div className="mt-4-res mt-3">
            <a className="brand-logo" href="https://rizee.in/">
              <Image src={logoBlue} alt="LOGO" className="res_show" />
              <Image src={logoWhite} alt="LOGO" className="res_hide" />
            </a>
          </div>

          <Scrollbars
            style={{ height: "calc(100vh - 100px)" }}
            renderThumbVertical={renderThumb}
            autoHide
            autoHideTimeout={500}
            autoHideDuration={200}
          >
            <Nav className="navbar-nav menu mt-4 mb-2">
              <Accordion defaultActiveKey={this.getAccordianActive()}>
                {/* {Array.from({ length: 15 }).map((_, index) => (
                        <div key={index}>

                          <div className="d-flex align-items-center mb-2">
                       
                            <div
                              style={{
                                width: "18px",
                                height: "18px",
                                background: "#e0e0e0",
                                borderRadius: "4px",
                                marginRight: "10px"
                              }}
                            ></div>

                         
                            <div
                              style={{
                                width: "100%",
                                height: "10px",
                                background: "#e0e0e0",
                                borderRadius: "4px"
                              }}
                            ></div>
                          </div>

               
                          <div className="w-100 border-bottom mb-3 opacity-25"></div>
                        </div>
                    */}


                <React.Fragment>
                  {
                    moduleRestrictions.Dashboard != undefined && moduleRestrictions.Dashboard == false ?
                      (
                        <Nav.Item>
                          <Link
                            className={this.getActiveClassTwo("/")}
                            to="/"
                          >
                            <i className="fal fa-fw fa-tachometer-alt"></i> <span>Dashboard</span>
                          </Link>
                        </Nav.Item>
                      ) : ("")
                  }

                  {
                    (moduleRestrictions.Exam_Made_Easy == false || moduleRestrictions.Manage_Exams == false || moduleRestrictions.Quiz == false || moduleRestrictions.View_Results == false || moduleRestrictions.academic_students == false) && !undefined ?
                      (
                        <div
                          className="mt-3 w-100 mb-3 group_type"
                          style={{
                            textAlign: "center",
                            borderBottom: "2px solid #ffc107",
                            paddingBottom: "4px"
                          }}
                        >
                          <h6 style={{ color: "#ffc107", margin: 0 }}>
                            ACADEMICS
                          </h6>
                        </div>
                      ) : ("")
                  }

                  {/* Online Exams */}
                  {
                    (moduleRestrictions.Exam_Made_Easy == false || moduleRestrictions.Manage_Exams == false || moduleRestrictions.Quiz == false || moduleRestrictions.View_Results == false) && !undefined ? (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={7} className="">
                            <i class="fas fa-thin fa-book"></i> <span style={{ marginRight: "55px" }}>Online Exams</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>

                          <Accordion.Collapse eventKey={7}>
                            <div className="collapse-inner rounded">

                              {moduleRestrictions.Exam_Made_Easy != undefined && moduleRestrictions.Exam_Made_Easy == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass("/exam_made_easy")}
                                    to="/exam_made_easy"
                                  >
                                    <i className="fal fa-fw fa-file-signature mr-2"></i>
                                    Exam Creation
                                  </Link>
                                </Nav.Item>
                              )}

                              {moduleRestrictions.Manage_Exams != undefined && moduleRestrictions.Manage_Exams == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass("/questions/manage-question-paper")}
                                    to="/questions/manage-question-paper"
                                  >
                                    <i className="fal fa-fw fa-file-contract mr-2"></i>
                                    Manage Exams
                                  </Link>
                                </Nav.Item>
                              )}

                              {moduleRestrictions.Quiz != undefined && moduleRestrictions.Quiz == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass("/quiz_section")}
                                    to="/quiz_section"
                                  >
                                    <i className="fal fa-fw fa-question-circle mr-2"></i>
                                    Quiz Creation
                                  </Link>
                                </Nav.Item>
                              )}

                              {moduleRestrictions.View_Results != undefined && moduleRestrictions.View_Results == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass("/ExamReport")}
                                    to="/ExamReport_tabs"
                                  >
                                    <i className="fal fa-fw fa-chart-bar mr-2"></i>
                                    Test Reports
                                  </Link>
                                </Nav.Item>
                              )}

                              {/* {
                                    moduleRestrictions.Send_notifications != undefined && moduleRestrictions.Send_notifications == false ?
                                      (
                                        <Nav.Item>
                                          <Link
                                            className={this.getActiveClass("/settings/adaptive-exams")}
                                            to="/settings/adaptive-exams"
                                          >
                                            <i className="fal fa-fw fa-brain mr-2"></i> <span>Adaptive Exams</span>
                                          </Link>
                                        </Nav.Item>
                                      )
                                      :
                                      ("")
                                  } */}


                              {/* {
                                    moduleRestrictions.Send_notifications != undefined && moduleRestrictions.Send_notifications == false ?
                                      (
                                        <Nav.Item>
                                          <Link
                                            className={this.getActiveClass("/settings/overall-college-report")}
                                            to="/settings/overall-college-report"
                                          >
                                            <i className="fal fa-fw fa-chart-bar mr-2 "></i> <span>Overall Report</span>
                                          </Link>
                                        </Nav.Item>
                                      )
                                      :
                                      ("")
                                  } */}


                              {
                                moduleRestrictions.Send_notifications != undefined && moduleRestrictions.Send_notifications == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/settings/PDF_upload")}
                                        to="/settings/PDF_upload"
                                      >
                                        <i className="fal fa-fw fa-file-pdf mr-2"></i> <span>PDF Upload Report</span>
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }

                  {/* Offline(OMR) Exams */}
                  {
                    (
                      moduleRestrictions.Exam_Made_Easy === false ||
                      moduleRestrictions.Manage_Exams === false ||
                      moduleRestrictions.Quiz === false ||
                      moduleRestrictions.View_Results === false) ? (
                      <Nav.Item>
                        <Accordion.Toggle as={Nav.Link} eventKey={8} className="d-flex align-items-center mb-2">
                          <i className="fas fa-thin fa-book"></i>
                          <span style={{ marginLeft: "8px" }}>Offline(OMR) Exams</span>
                          <i
                            className="fas fa-caret-down"
                            style={{ color: "#F8C52C", marginLeft: "auto" }}
                          ></i>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={8}>
                          <div className="collapse-inner rounded">
                            {[
                              {
                                key: "Exam_Made_Easy",
                                label: "History",
                                to: "/offline_exams/omr/history",
                                icon: ExamCreationImg,
                              },
                              {
                                key: "Exam_Made_Easy",
                                label: "Exam Creation",
                                to: "/offline_exams/exam_made_easy",
                                icon: ExamCreationImg,
                              },
                              {
                                key: "Manage_Exams",
                                label: "Scheduled Exams",
                                to: "/offline_exams/manage-question-paper",
                                icon: ManageExamsImg,
                              },
                              {
                                key: "View_Results",
                                label: "Exam Reports",
                                to: "/offline_exams/ExamReport",
                                icon: ExamReportsImg,
                              }
                            ]
                              .filter(item => moduleRestrictions[item.key] === false)
                              .map((item, index) => (
                                <Nav.Item key={index}>
                                  <Link
                                    className={this.getActiveClass(item.to)}
                                    to={item.to}
                                  >
                                    <Image src={item.icon} className="ml-1 mr-3" alt="New" width="15" height="15" />
                                    <span>{item.label}</span>
                                  </Link>
                                </Nav.Item>
                              ))}
                          </div>
                        </Accordion.Collapse>
                      </Nav.Item>
                    ) : null
                  }

                  {/* Mock Test Analysis && Course Exams */}
                  {
                    Cookies.get("institutionid") === 19 ?
                      (
                        <>
                          <Nav.Item>
                            <Link
                              className={this.getActiveClassTwo("/lec_paper_generator")}
                              to="/lec_paper_generator"
                            >
                              <i className="fal fa-file-contract mr-2 mb-1 mt-1"></i><span>Mock Test Analysis</span>
                            </Link>
                          </Nav.Item>

                          <Nav.Item>
                            <Link
                              className={this.getActiveClassTwo("/mocktest-analysis")}
                              to="/mocktest-analysis"
                            >
                              <i className="fal fa-file-alt mr-2 mb-1 mt-1"></i><span>Course Exams</span>
                            </Link>
                          </Nav.Item>
                        </>
                      )
                      :
                      ("")
                  }

                  {
                    (moduleRestrictions.admission_form == false || moduleRestrictions.admission_form_list == false || moduleRestrictions.Student_Attendance == false || moduleRestrictions.Student_Attendance_report == false || moduleRestrictions.offline_marks_uploading == false || moduleRestrictions.offline_marks_Results == false || moduleRestrictions.Fee_Structure == false || moduleRestrictions.Student_Attendance == false || moduleRestrictions.Student_Attendance == false || moduleRestrictions.Hostel_Buildings == false || moduleRestrictions.Permissions == false || moduleRestrictions.Hostel_Attendance || moduleRestrictions.Diary == false || moduleRestrictions.Hostel_Attendance_Report == false || moduleRestrictions.Material_Allocation == false || moduleRestrictions.Assignments == false || moduleRestrictions.non_academic_students != undefined && moduleRestrictions.non_academic_students == false) && !undefined ?
                      (
                        <>
                          <div
                            className="mt-3 w-100 mb-3 group_type"
                            style={{
                              textAlign: "center",
                              borderBottom: "2px solid #ffc107",
                              paddingBottom: "4px"
                            }}
                          >
                            <h6 style={{ color: "#ffc107", margin: 0 }}>
                              NON-ACADEMICS
                            </h6>
                          </div>
                        </>
                      ) : null
                  }

                  {
                    (moduleRestrictions.Student_Attendance == false || moduleRestrictions.Student_Attendance_report == false || moduleRestrictions.Student_Attendance == false || moduleRestrictions.Student_Attendance == false || moduleRestrictions.Hostel_Attendance == false || moduleRestrictions.Hostel_Attendance_Report == false) && !undefined ? (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={3} className="">
                            <i class="fas fa-clipboard-user"></i> <span style={{ marginRight: "71px" }}>Attendance</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={3}>
                            <div className="collapse-inner rounded">

                              {
                                moduleRestrictions.Student_Attendance != undefined && moduleRestrictions.Student_Attendance == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student/attendance")}
                                        to="/student/attendance"
                                      >
                                        {/* <i class="fas fa-users"></i>Student Attendance */}
                                        <Image src={StudentAttendanceImg} className="ml-1 mr-1 " alt="New" width="15" height="15" />Student Attendance

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                              {
                                moduleRestrictions.Student_Attendance_report != undefined && moduleRestrictions.Student_Attendance_report == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student/attendance-report")}
                                        to="/student/attendance-report"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Student Attendance Report */}
                                        <Image src={StudentAtnReportImg} className="ml-1 mr-1 " alt="New" width="15" height="15" />Student Attendance Report

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.Student_Attendance != undefined && moduleRestrictions.Student_Attendance == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/Employee_Attendance")}
                                        to="/Employee_Attendance"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Employee Attendance */}
                                        <Image src={EmpAttendanceImg} className="ml-1 mr-1 " alt="New" width="15" height="15" />Employee Attendance
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.Student_Attendance != undefined && moduleRestrictions.Student_Attendance == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/Employee_Attendance_Report")}
                                        to="/Employee_Attendance_Report"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Employee Attendance Report */}
                                        <Image src={EmpAttendanceReportImg} className="ml-1 mr-1" alt="New" width="15" height="15" />Employee Attendance Report
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.Hostel_Attendance != undefined && moduleRestrictions.Hostel_Attendance == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/hostel-attendance")}
                                        to="/hostel-attendance"
                                      >
                                        {/* <i class="fas fa-users"></i>Hostel Attendance */}
                                        <Image src={HostelAtnImp} className="ml-1 mr-1" alt="New" width="15" height="15" /> Hostel Attendance

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                              {
                                moduleRestrictions.Hostel_Attendance_Report != undefined && moduleRestrictions.Hostel_Attendance_Report == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/hostel/attendance-report")}
                                        to="/hostel/attendance-report"
                                      >
                                        {/* <i class="fas fa-users"></i>Hostel Attendance Report */}
                                        <Image src={HostelAtnReportImp} className="ml-1 mr-1" alt="New" width="15" height="15" />Hostel Attendance Report

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }


                  {
                    (moduleRestrictions.admission_form_list == false || moduleRestrictions.admission_form == false || moduleRestrictions.Enquiry_management == false || moduleRestrictions.Lead_management == false) && !undefined ? (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={4} className="">
                            <i class="fas fa-thin fa-head-side-headphones"></i> <span style={{ marginRight: "75px" }}>Admissions</span><i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={4}>
                            <div className="collapse-inner rounded">
                              {
                                moduleRestrictions.admission_dashboard != undefined && moduleRestrictions.admission_dashboard == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/admissions-dashboard")}
                                        to="/admissions-dashboard"
                                      >
                                        <i className="fal fa-tachometer-alt ml-1 mr-3" style={{ color: "#F8C52C", fontSize: "15px" }}></i>Dashboard
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  (
                                    moduleRestrictions.admission_dashboard == undefined ? (
                                      <Nav.Item>
                                        <Link
                                          className={this.getActiveClass("/admissions-dashboard")}
                                          to="/admissions-dashboard"
                                        >
                                          <i className="fal fa-tachometer-alt ml-1 mr-3" style={{ color: "#F8C52C", fontSize: "15px" }}></i>Dashboard
                                        </Link>
                                      </Nav.Item>
                                    ) : ""
                                  )
                              }
                              {
                                moduleRestrictions.admission_form != undefined && moduleRestrictions.admission_form == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student-admission")}
                                        to="/student-admission"
                                      >
                                        {/* <i className="fal fa-file-signature"></i>Admission Form */}
                                        <Image src={AdmissionFormImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Admission Form


                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.admission_form_list != undefined && moduleRestrictions.admission_form_list == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student-admission-list")}
                                        to="/student-admission-list"
                                      >
                                        {/* <i className="fal fa-file-signature"></i>Edmitted Students */}
                                        <Image src={EnrolledStudentsImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Admitted Students

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.Enquiry_management != undefined && moduleRestrictions.Enquiry_management == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/enquiry-links")}
                                        to="/enquiry-links"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Enquiry links */}
                                        <Image src={EnquiryLinksImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Enquiry links
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.Lead_management != undefined && moduleRestrictions.Lead_management == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/lead-management-home")}
                                        to="/lead-management-home"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Lead Management */}
                                        <Image src={LeadManagementImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Lead Management
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }


                  {
                    (moduleRestrictions.Diary == false || moduleRestrictions.Assignments == false) && !undefined ? (

                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={5} className="">
                            <i class="fal fa-fw fa-book"></i> <span style={{}}>Dairy && Asgmt</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={5}>
                            <div className="collapse-inner rounded">

                              {
                                moduleRestrictions.Diary != undefined && moduleRestrictions.Diary == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student-diary")}
                                        to="/student-diary"
                                      >
                                        {/* <i className="fal fa-file-signature"></i>Diary */}
                                        <Image src={DiaryImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Diary

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                              {
                                moduleRestrictions.Assignments != undefined && moduleRestrictions.Assignments == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/assignment")}
                                        to="/assignment"
                                      >
                                        {/* <i class="fas fa-users"></i>Assignments */}
                                        <Image src={AssignmentsImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Assignments

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }


                  {
                    (moduleRestrictions.offline_marks_uploading == false || moduleRestrictions.offline_marks_Results == false) && !undefined ? (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={6} className="">
                            <i class="fal fa-fw fa-tasks"></i> <span style={{}}>Offline Exams</span><i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={6}>
                            <div className="collapse-inner rounded">

                              {
                                moduleRestrictions.offline_marks_uploading != undefined && moduleRestrictions.offline_marks_uploading == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student/marks-upload")}
                                        to="/student/marks-upload"
                                      >
                                        {/* <i class="fal fa-address-card"></i>Exam Marks Upload */}
                                        <Image src={ExamMarkUploadImg} className="ml-1 mr-1" alt="New" width="15" height="15" />Marks Uploading
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                              {
                                moduleRestrictions.offline_marks_Results != undefined && moduleRestrictions.offline_marks_Results == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student/offline-exam-results")}
                                        to="/student/offline-exam-results"
                                      >
                                        {/* <i class="fal fa-address-card"></i>Offline Exam Performance Reports */}
                                        <Image src={ExamReportsImg} className="ml-1 mr-1" alt="New" width="15" height="15" />Exam Report

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }



                  {
                    (moduleRestrictions.Permissions == false || moduleRestrictions.Permission_pass == false) && !undefined ? (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={12} className="">
                            <i class="fal fa-fw fa-user-check"></i> <span style={{}}>Permissions</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>

                          <Accordion.Collapse eventKey={12}>
                            <div className="collapse-inner rounded">

                              {
                                moduleRestrictions.Permissions != undefined && moduleRestrictions.Permissions == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/student-permission")}
                                        to="/student-permission"
                                      >
                                        {/* <i className="fal fa-file-signature"></i>Permissions */}
                                        <Image src={PermissionsImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Permissions

                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                              {
                                moduleRestrictions.Permission_pass != undefined && moduleRestrictions.Permission_pass == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/Student_Gate_Pass")}
                                        to="/Student_Gate_Pass"
                                      >
                                        {/* <i class="fa fa-file" aria-hidden="true"></i>Gate Pass */}
                                        <Image src={GatePassImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Gate Pass
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }


                  {/* MATERIALS */}
                  {
                    (moduleRestrictions.Custom_Materials != undefined && moduleRestrictions.Custom_Materials == false && moduleRestrictions.Material_Allocation != undefined && moduleRestrictions.Material_Allocation == false) && !undefined ? (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={9} className="">
                            <i class="fal fa-fw fa-folder-open"></i> <span style={{ marginRight: "55px" }}>Materials</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>

                          <Accordion.Collapse eventKey={9}>

                            <div className="collapse-inner rounded">
                              {moduleRestrictions.Custom_Materials != undefined && moduleRestrictions.Custom_Materials == false && (
                                <Nav.Item>
                                  <Link
                                    className={this.getActiveClass("/inst_revision_material")}
                                    to="/inst_revision_material"
                                  >
                                    <Image src={FeeDetailsImg} className="ml-1 mr-3" alt="New" width="15" height="15" />Custom Materials
                                  </Link>
                                </Nav.Item>
                              )}

                              {
                                moduleRestrictions.Material_Allocation != undefined && moduleRestrictions.Material_Allocation == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/material-assigning")}
                                        to="/material-assigning"
                                      >
                                        <i className="fal fa-fw fa-box-open mr-2"></i> <span>Material Allocation</span>
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    ) : null
                  }

                  {
                    (moduleRestrictions.parent_notifications != undefined || moduleRestrictions.parent_notifications == true ||
                      moduleRestrictions.Send_notifications != undefined || moduleRestrictions.Send_notifications == true
                    ) && (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={11} className="">
                            <i class="fal fa-fw fa-bell"></i> <span style={{ marginRight: "55px" }}>Notification</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>

                          <Accordion.Collapse eventKey={11}>

                            <div className="collapse-inner rounded">

                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass("/Parent_Notification")}
                                  to="/Parent_Notification"
                                >
                                  <i className="fal fa-fw fa-bell-school mr-2"></i> <span>Notify Parents</span>
                                </Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Link
                                  className={this.getActiveClass("/settings/notify-students")}
                                  to="/settings/notify-students"
                                >
                                  <i className="fal fa-fw fa-users mr-2"></i> <span>Notify Students</span>
                                </Link>
                              </Nav.Item>

                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    )
                  }

                  {
                    moduleRestrictions.Fee_Structure != undefined && moduleRestrictions.Fee_Structure == false ?
                      (
                        <Nav.Item>
                          <Link
                            className={this.getActiveClassTwo("/Fee-Structure")}
                            to="/Fee-Structure"
                          >
                            <i className="fal fa-fw fa-money-bill-wave mr-2 mb-1 mt-1"></i> <span>Fee Details</span>
                          </Link>
                        </Nav.Item>
                      )
                      :
                      ("")
                  }

                  {
                    moduleRestrictions.Lecturer_timetable != undefined && moduleRestrictions.Lecturer_timetable == false ?
                      (
                        <Nav.Item>
                          <Link
                            className={this.getActiveClassTwo("/lecturer-timeTable")}
                            to="/lecturer-timeTable"
                          >
                            <i className="fal fa-fw fa-calendar-alt mr-2 mt-1 mb-1"></i> <span>Lecture Time Table</span>
                          </Link>
                        </Nav.Item>
                      )
                      :
                      ("")
                  }

                  {
                    moduleRestrictions.Hostel_Buildings != undefined && moduleRestrictions.Hostel_Buildings == false ?
                      (
                        <Nav.Item>
                          <Link className={this.getActiveClassTwo("/building-creation")}
                            to="/building-creation">
                            <i className="fal fa-fw fa-building mr-2 mb-1 mt-1"></i> <span>Building Creation</span>
                          </Link>
                        </Nav.Item>
                      ) : ("")

                  }

                  <div
                    className="mt-3 w-100 mb-3 group_type"
                    style={{
                      textAlign: "center",
                      borderBottom: "2px solid #ffc107",
                      paddingBottom: "4px"
                    }}
                  >
                  </div>


                  {
                    (moduleRestrictions.academic_students != undefined && moduleRestrictions.academic_students == false) && (
                      <>
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={10} className="">
                            <i class="fas fa-thin fa-book"></i> <span style={{ marginRight: "55px" }}>Students</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>

                          <Accordion.Collapse eventKey={10}>

                            <div className="collapse-inner rounded">
                              {
                                moduleRestrictions.academic_students != undefined && moduleRestrictions.academic_students == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/settings/students")}
                                        to="/settings/students"
                                      >
                                        <i className="fas fa-book-reader"></i> <span>Academic Students</span>
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }

                              {
                                moduleRestrictions.non_academic_students != undefined && moduleRestrictions.non_academic_students == false ?
                                  (
                                    <Nav.Item>
                                      <Link
                                        className={this.getActiveClass("/settings/instituteStudents")}
                                        to="/settings/instituteStudents">
                                        <i className="fal fa-fw fa-user-graduate"></i> <span>Non Academic Student</span>
                                      </Link>
                                    </Nav.Item>
                                  )
                                  :
                                  ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      </>
                    )
                  }

                  {/* Settings */}
                  {
                    moduleRestrictions.Settings != undefined && moduleRestrictions.Settings == false ?
                      (
                        <Nav.Item>
                          <Accordion.Toggle as={Nav.Link} eventKey={2} className="">
                            <i className="fal fa-cogs mr-2"></i> <span style={{ marginRight: "83px" }}>Settings</span>
                            <i className="fas fa-caret-down" style={{ color: "#F8C52C", marginLeft: "auto" }}></i>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={2}>
                            <div className="collapse-inner rounded">
                              {
                                moduleRestrictions.user_creation != undefined && moduleRestrictions.user_creation == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/user-creations")}
                                      to="/settings/user-creations"
                                    ><i className="fal fa-user" /> User Creations</Link>

                                  ) : ("")

                              }
                              {
                                moduleRestrictions.Employee_Restrctions != undefined && moduleRestrictions.Employee_Restrctions == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/employee-restrictions")}
                                      to="/settings/employee-restrictions"

                                    >
                                      <i className="fal fa-book-reader" /> Employee Creation
                                    </Link>
                                  ) : ("")

                              }
                              {
                                moduleRestrictions.package != undefined && moduleRestrictions.package == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/package")}
                                      to="/settings/package">
                                      <i className="fal fa-box" /> Package
                                    </Link>
                                  ) : ("")

                              }
                              {
                                moduleRestrictions.categories != undefined && moduleRestrictions.categories == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/category")}
                                      to="/settings/category"
                                    >
                                      <i className="fal fa-album-collection" /> Categories
                                    </Link>
                                  ) : ("")

                              }
                              {
                                moduleRestrictions.branches != undefined && moduleRestrictions.branches == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/branches")}
                                      to="/settings/branches"

                                    >
                                      <i className="fas fa-building" /> Branches
                                    </Link>
                                  ) : ("")

                              }
                              {
                                moduleRestrictions.sections != undefined && moduleRestrictions.sections == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/add-section")}
                                      to="/settings/add-section"

                                    >
                                      <i className="fal fa-layer-group" /> Section
                                    </Link>
                                  ) : ("")

                              }
                              {
                                moduleRestrictions.organization_profile != undefined && moduleRestrictions.organization_profile == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass(
                                        "/settings/organization-profile"
                                      )}
                                      to="/settings/organization-profile"

                                    >
                                      <i className="fal fa-container-storage" /> Organization
                                      Profile
                                    </Link>
                                  ) : ("")

                              }
                              {
                                moduleRestrictions.groups != undefined && moduleRestrictions.groups == false ?
                                  (
                                    <Link
                                      className={this.getActiveClass("/settings/groups")}
                                      to="/settings/groups"

                                    >
                                      <i className="fal fa-users" /> Groups
                                    </Link>
                                  ) : ("")
                              }
                            </div>
                          </Accordion.Collapse>
                        </Nav.Item>
                      )
                      :
                      ("")
                  }
                </React.Fragment>

              </Accordion>
            </Nav>
          </Scrollbars>
        </div>

        {
          this.state.rizeeLogo ? ("") : (
            <p className="product_brand text-center">
              <span className="powered_text">Powered by </span>
              <span className="product_brand_sub">Rizee</span>
            </p>
          )
        }
      </div >
    );

  }
}
export default withRouter(SideNavbar);